import { SubscriptionResponse } from '@commerce-subscription-webcomponents/sdk';

export enum EnableProxyOrderConsumerType {
  SubscriptionCheckout = 'SubscriptionCheckout',
  AddToCartButton = 'AddToCartButton',
}

export type EnableProxyOrderPropTypes = {
  consumer: string;
  subscriptionDetails: SubscriptionResponse;
  addToCartBtnClicked?: boolean;
  onEnablement?: () => void;
};
